import React from "react";
import { Droppable } from "react-beautiful-dnd";
import { observer } from "mobx-react-lite";

import "../DragAndDropTable.scss";
import DragAndDropItem from "./DragAndDropItem";
import { Column } from "../../../services/organization/ProjectPropertyStorage";
import { translationService } from "../../../services/translation/TranslationService";

export interface ColumnProps {
  column: Column;
  rowClickCallback: (item: any) => void;
}

export default observer(function DragAndDropColumn(props: ColumnProps) {
  return (
    <>
      <div className="dnd-table-row column">
        <div className="dnd-tale-cell">{`${translationService.translate("general.column")} ${
          props.column.name
        }`}</div>
      </div>
      <Droppable droppableId={props.column.id.toString()}>
        {(provided, snapshot) => (
          <div
            key={props.column.id.toString()}
            className={
              snapshot.isDraggingOver ? "droppable-content draggingOver" : "droppable-content"
            }
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {props.column.properties.map((item, index) => {
              return <DragAndDropItem key={item.id} data={item} index={index} rowClickCallback={props.rowClickCallback}/>;
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
});
